/**
 * Shape shared by the booking widget's call-to-action buttons: a 48px height
 * floor (min-height so longer, wrapped labels still fit) and an 8px corner
 * radius.
 */
export const CTA_SHAPE = "gcw:min-h-12 gcw:rounded-md gcw:py-2";

/** {@link CTA_SHAPE} for the CTAs that span the full width of the widget. */
export const CTA_FULL_WIDTH = `gcw:w-full ${CTA_SHAPE}`;
